import environment from '@environments/environment';

export const DOCUMENTS_URL = `${environment.irisApi}/document/`;

export const DOCUMENTS_V2_URL = `${environment.irisApi}/v2/document/`;

/** Toast shown when a document page is opened for a document that has been deleted. */
export const DELETED_DOCUMENT_MESSAGE =
  'The document you are trying to access was deleted';
